import { Action, Module, VuexModule } from "vuex-module-decorators";
import { Report } from "@/store/enums/StoreEnums";
import ApiService from "@/core/services/ApiService";
import { CookieComponent } from "@/assets/ts/components";

@Module
export default class ReportModule extends VuexModule {
    @Action
    [Report.partnerRevenue]() {
        return new Promise<void>((resolve, reject) => {
            ApiService.post(`/report/partnerRevenue`,{})
                .then(({ data }) => {
                    resolve(data);
                })
                .catch(({ response }) => {
                    reject(response);
                });
        });
    }
}